import Swal from 'sweetalert2';

export const showAlertNumberInput = (title, text, placeholder, callback) => {
  Swal.fire({
    title: title,
    text: text,
    input: 'number',
    inputPlaceholder: placeholder,
    showCancelButton: true,
    confirmButtonText: 'Aceptar',
    cancelButtonText: 'Cancelar'
  }).then((result) => {
    if (result.isConfirmed) {
      callback(result.value);
    }
  });
};

export const showAlertTextInput = (title, text, placeholder, buttonText, icon, callback) => {
  Swal.fire({
    title: title,
    text: text,
    icon: icon,
    input: 'text',
    inputPlaceholder: placeholder,
    showCancelButton: true,
    confirmButtonText: buttonText,
    cancelButtonText: 'Cancelar'
  }).then((result) => {
    if (result.isConfirmed) {
      callback(result.value);
    }
  });
};

export const showAlertWithAutoClose = async (title, htmlContent, icon, timer = 2000) => {
  return new Promise((resolve) => {
    Swal.fire({
      title: title,
      html: htmlContent,
      icon: icon,
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'Ok',
      timer: timer,
      timerProgressBar: true,
      showConfirmButton: false,
      heightAuto: false
    }).then(() => {
      resolve();
    });
  });
};

export const showConfirmAlert = (title, text, confirmButtonText, icon, callback) => {
  Swal.fire({
    title: title,
    text: text,
    icon: icon,
    showCancelButton: true,
    confirmButtonText: confirmButtonText,
    cancelButtonText: 'Cancelar'
  }).then((result) => {
    if (result.isConfirmed) {
      callback();
    }
  });
};

export const showAlertWithSingleButton = async (title, htmlContent, icon, buttonText) => {
  return new Promise((resolve) => {
    Swal.fire({
      title: title,
      html: htmlContent,
      icon: icon,
      confirmButtonColor: '#3085d6',
      confirmButtonText: buttonText,
      showConfirmButton: true,
      heightAuto: false
    }).then(() => {
      resolve();
    });
  });
};

export const showAlertWithSelect = async (title, text, selectOptions, placeholder, confirmButtonText, icon, callback) => {
  return new Promise((resolve) => {
    Swal.fire({
      title: title,
      text: text,
      icon: icon,
      input: 'select',
      inputOptions: selectOptions,
      inputPlaceholder: placeholder,
      showCancelButton: true,
      confirmButtonText: confirmButtonText,
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        callback(result.value);
      }
      resolve();
    });
  });
};
